module.exports = __webpack_public_path__ + "static/media/bg.ce95a749.svg";